/* eslint-disable */ 
//import _ from 'lodash'
/* eventAverage */
import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import { Tabs, Tab, Row, Col, Table } from 'react-bootstrap';
import { BootstrapTable, TableHeaderColumn } from 'react-bootstrap-table';
import { divisionEventAverageFilter } from '../../../utils/functions';
import { DIVISIONS,EventAverageHeaders } from '../../../utils/constants';
import  Navwrapper  from '../../layout/Navigation';
import Footer from '../../layout/Footer';
import { getEventAverageBySeason } from '../api'
import { exportCSV, tableOptions} from '../common'
export default class EventAveragePage extends Component {

  constructor(props) {
    super(props);
    const { match } = this.props
    this.state = {
        eventAveragesAll:[],
        seasonId:match.params.seasonId,
        eventId:match.params.eventId,
        eventName:match.params.eventName,
        seasonName:match.params.seasonName
    };
  }
  componentDidMount() {
    const _this = this
    getEventAverageBySeason(_this.state.seasonId,_this.state.eventId).then(function(response) {
       _this.setState({ eventAveragesAll: response.data }) 
   })
  
   }
  playerNameFormatter(cell, row ) {
      var link = `/playerProfile/${row.seasonId}/${row.playerId}`;
    return <Link to={link}>{cell}</Link>;      
  }  

  teamNameFormatter(cell, row, props) {
    var link =  `/schoolAverage/${row.seasonId}/${row.eventId}/${row.teamId}/${props.match.params.eventName}/${props.match.params.seasonName}/${row.school}`
    + ( (row.division == 'M') ? '/true': '/false')+ ( (row.isVarsity == true) ? '/true': '/false');    
    return (
            <div className="cellLinks">
                <Link className="cellLinksLeft" to={link}>{row.tm}</Link>
            </div>
          );        
  }     

  totalsRow(tabDataVarsity) {
    var pinSumVarsity = tabDataVarsity.reduce( function(cnt,i){ return cnt + i.total;},0);    
    var gameSumVarsity = tabDataVarsity.reduce( function(cnt,i){ return cnt + i.gm;},0);
    var fieldAvg =  (pinSumVarsity)/(gameSumVarsity);  
    // console.log("pinSum",pinSum);
    // console.log("gameSum",gameSum)
    return  <tr >
                <td>Field Average:</td>
                <td>{fieldAvg.toFixed(4)}</td>
                <td>Games Bowled:</td>
                <td>6 Team</td>
            </tr>       
  }    
  render() {
    const _this = this
    const { match } = this.props

    const eventName = match.params.eventName
    const seasonName = match.params.seasonName
    const averagesMen = match.params.averagesMen
    
    let defaultTab = 1;
    if (averagesMen === 'false') {
      defaultTab = 2
    }    
    const EventAveragesAll =_this.state.eventAveragesAll;
    
    const menVarsityEventAverages = EventAveragesAll
                        .filter((averages) => divisionEventAverageFilter(averages, DIVISIONS.MEN));
    const womenVarsityEventAverages = EventAveragesAll
                        .filter((averages) => divisionEventAverageFilter(averages, DIVISIONS.WOMEN));

    return (
      <div>
        <Navwrapper />
        <div className="container-fluid">
          <Row>
            <div className="pageHeading" >
                <h4>{seasonName}</h4>
                  <h4 >
                      {eventName}<br/>
                          Individual Averages
                  </h4>
            </div>
          </Row>      
          <Row>                 
            <Col xs={12} >                           
              <div className="rankingRightColumn_"> 
                <Tabs defaultActiveKey={defaultTab} id="ind-avg-event-tabs">
                  <Tab eventKey={1} title="MEN">           
                      <BootstrapTable 
                        data={menVarsityEventAverages} 
                        striped 
                        hover 
                        options={tableOptions}
                        pagination               
                      >
                          <TableHeaderColumn          
                            dataField="id" 
                            isKey 
                            dataAlign="right" 
                            dataSort 
                            data-Visible="false"               
                            hidden                 
                          >ID
                          </TableHeaderColumn>
                          <TableHeaderColumn dataField="no" dataSort width="2%" >NO
                          </TableHeaderColumn>
                          <TableHeaderColumn 
                            dataField="name" 
                            dataAlign="left"
                            dataFormat={this.playerNameFormatter}  
                            width="2%" 
                          >NAME
                          </TableHeaderColumn>
                          <TableHeaderColumn dataField="school" dataAlign="left"  width="2%" >SCHOOL
                          </TableHeaderColumn>
                          <TableHeaderColumn 
                            dataField="tm" 
                            dataAlign="right"  
                            dataFormat={this.teamNameFormatter} 
                            formatExtraData={this.props}
                            width="2%" 
                          >TM
                          </TableHeaderColumn>
                          <TableHeaderColumn dataField="total" dataAlign="right"  width="2%" >TOTAL
                          </TableHeaderColumn>
                          <TableHeaderColumn dataField="gm" dataAlign="right"  width="2%" >GM
                          </TableHeaderColumn>
                          <TableHeaderColumn dataField="avg" dataAlign="right"  width="2%" >AVG
                          </TableHeaderColumn>                  
                      </BootstrapTable>                    
                      <Row className="blank_row" />
                      { exportCSV(menVarsityEventAverages,EventAverageHeaders,'MensEventAverages - '+ eventName +'.csv') }
                      <Row >
                        <Col xs={3} />
                        <Col xs={6}>                                                
                          <Table className="totals_table"  >
                            <thead >
                              <tr >
                                <th/>
                                <th/>
                                <th/>
                                <th/>                              
                              </tr>
                            </thead>
                            <tbody>                            
                            { this.totalsRow(menVarsityEventAverages) }
                              {/* <tr >
                                <td>Field Average:</td>
                                <td>185.1727</td>
                                <td>Games Bowled:</td>
                                <td>6 Team</td>
                              </tr>        */}

                            </tbody>
                          </Table>
                        </Col>
                      </Row>    
                  </Tab>
                  <Tab eventKey={2} title="WOMEN">
                        <BootstrapTable 
                          data={womenVarsityEventAverages} 
                          striped 
                          hover 
                          options={tableOptions}
                          pagination               
                        >
                            <TableHeaderColumn          
                              dataField="id" 
                              isKey 
                              dataAlign="right" 
                              dataSort 
                              data-Visible="false"               
                              hidden                 
                            >ID
                            </TableHeaderColumn>
                            <TableHeaderColumn dataField="no" dataSort width="2%" >NO
                            </TableHeaderColumn>
                            <TableHeaderColumn 
                              dataField="name" 
                              dataAlign="left"
                              dataFormat={this.playerNameFormatter}  
                              width="2%" 
                            >NAME
                            </TableHeaderColumn>
                            <TableHeaderColumn dataField="school" dataAlign="left"  width="2%" >SCHOOL
                            </TableHeaderColumn>
                            <TableHeaderColumn 
                              dataField="tm" 
                              dataAlign="right"  
                              dataFormat={this.teamNameFormatter} 
                              formatExtraData={this.props}
                              width="2%" 
                            >TM
                            </TableHeaderColumn>
                            <TableHeaderColumn dataField="total" dataAlign="right"  width="2%" >TOTAL
                            </TableHeaderColumn>
                            <TableHeaderColumn dataField="gm" dataAlign="right"  width="2%" >GM
                            </TableHeaderColumn>
                            <TableHeaderColumn dataField="avg" dataAlign="right"  width="2%" >AVG
                            </TableHeaderColumn>                  
                        </BootstrapTable>

                        <Row className="blank_row" />
                        { exportCSV(womenVarsityEventAverages,EventAverageHeaders,'WomensEventAverages - '+ eventName +'.csv') }
                        <Row >
                          <Col xs={3} />
                          <Col xs={6}>                                                
                            <Table className="totals_table"  >
                              <thead >
                                <tr >
                                  <th/>
                                  <th/>
                                  <th/>
                                  <th/>                                
                                </tr>
                              </thead>
                              <tbody>
                                { this.totalsRow(womenVarsityEventAverages)}                                
                              {/* <tr >
                                  <td>Field Average:</td>
                                  <td>165.7667</td>
                                  <td>Games Bowled:</td>
                                  <td>6 Team</td>
                                </tr>        */}

                              </tbody>
                            </Table>
                          </Col>
                        </Row>                        
                  </Tab>
                </Tabs>
              </div>
            </Col>
          </Row>
        </div>
        <Footer />      
      </div>
    ); 
  }                       
}


// WEBPACK FOOTER //
// ./src/components/pages/eventAverage/index.js